export default __webpack_public_path__ + "static/media/il-login-circle.6455b541.svg";